var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"contacts-wrapper flex flex-row",class:{'announcement-space': _vm.showAnnouncement }},[_c('ContactsTable',{staticClass:"greedy"}),_c('RightPanel',{staticClass:"panel",attrs:{"menu-acts-as-toggle":false,"initial-section":"info"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }